
import { Component, Vue, Prop } from "vue-property-decorator";
import ActivityItem from "./ActivityItem.vue";
import { formatUpyunUrl } from "@/utils";

@Component({
  components: {
    ActivityItem
  }
})
export default class Activity extends Vue {
  @Prop({ required: true }) private list!: any;
  formatUpyunUrl = formatUpyunUrl;
  //   当前位置
  index: any = 0;
  handleMore() {
    this.$router.push(`/activity`);
  }
  onHover(index: any) {
    if (this.index != index) {
      this.index = index;

      this.list.map((item: any) => {
        item.select = false;
      });

      this.list[index].select = true;
      const carousel: any = this.$refs.carousel;
      carousel.setActiveItem(index); //调动setActiveItem方法，动态切换图片
    }
  }
  changeCarousel(index: any) {
    if (this.index != index) {
      this.index = index;

      this.list.map((item: any) => {
        item.select = false;
      });

      this.list[index].select = true;
    }
  }

  handleDetail() {
    this.$router.push(
      `activity-detail?id=${this.list[this.index].activity_id}`
    );
  }
}
